(function () {
  var STORAGE_KEYS = {
    viewedProducts: 'st_viewed_products',
    categoryAffinity: 'st_category_affinity',
    vendorAffinity: 'st_vendor_affinity',
    searchTerms: 'st_search_terms',
    priceRange: 'st_price_range',
    utmCampaign: 'st_utm_campaign',
    lastUpdated: 'st_signals_updated',
  };

  var TTL_DAYS = {
    viewedProducts: 30,
    affinity: 30,
    searchTerms: 7,
    priceRange: 30,
  };

  var MAX_ITEMS = {
    viewedProducts: 50,
    searchTerms: 20,
    priceHistory: 20,
  };

  function nowMs() {
    return Date.now();
  }

  function safeParse(raw, fallback) {
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function isStorageAvailable(name) {
    try {
      var storage = window[name];
      var key = '__st_probe__';
      storage.setItem(key, '1');
      storage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  function getEmptySignals() {
    return {
      viewedProducts: [],
      categoryAffinity: {},
      vendorAffinity: {},
      searchTerms: [],
      priceRange: null,
    };
  }

  function PersonalizationSignals() {
    this.hasLocalStorage = isStorageAvailable('localStorage');
    this.hasSessionStorage = isStorageAvailable('sessionStorage');
    this.signals = getEmptySignals();
    this.init();
  }

  PersonalizationSignals.prototype.init = function () {
    if (this.hasLocalStorage) {
      this.cleanExpiredData();
      this.signals = this.load();
    }

    this.captureUTMParams();
  };

  PersonalizationSignals.prototype.load = function () {
    return {
      viewedProducts: safeParse(localStorage.getItem(STORAGE_KEYS.viewedProducts), []),
      categoryAffinity: safeParse(localStorage.getItem(STORAGE_KEYS.categoryAffinity), {}),
      vendorAffinity: safeParse(localStorage.getItem(STORAGE_KEYS.vendorAffinity), {}),
      searchTerms: safeParse(localStorage.getItem(STORAGE_KEYS.searchTerms), []),
      priceRange: safeParse(localStorage.getItem(STORAGE_KEYS.priceRange), null),
    };
  };

  PersonalizationSignals.prototype.save = function () {
    if (!this.hasLocalStorage) return;

    try {
      localStorage.setItem(STORAGE_KEYS.viewedProducts, JSON.stringify(this.signals.viewedProducts));
      localStorage.setItem(STORAGE_KEYS.categoryAffinity, JSON.stringify(this.signals.categoryAffinity));
      localStorage.setItem(STORAGE_KEYS.vendorAffinity, JSON.stringify(this.signals.vendorAffinity));
      localStorage.setItem(STORAGE_KEYS.searchTerms, JSON.stringify(this.signals.searchTerms));
      localStorage.setItem(STORAGE_KEYS.priceRange, JSON.stringify(this.signals.priceRange));
      localStorage.setItem(STORAGE_KEYS.lastUpdated, String(nowMs()));
    } catch (e) {
      // Ignore write failures (private mode / full storage).
    }
  };

  PersonalizationSignals.prototype.cleanExpiredData = function () {
    try {
      var lastUpdated = parseInt(localStorage.getItem(STORAGE_KEYS.lastUpdated) || '0', 10);
      if (!lastUpdated) return;

      var ageDays = (nowMs() - lastUpdated) / (1000 * 60 * 60 * 24);
      if (ageDays > Math.max(TTL_DAYS.viewedProducts, TTL_DAYS.affinity, TTL_DAYS.priceRange, TTL_DAYS.searchTerms)) {
        this.clearAll();
      }
    } catch (e) {
      // Ignore cleanup failures.
    }
  };

  PersonalizationSignals.prototype.trackProductView = function (product) {
    if (!product || !product.id) return;

    var productId = String(product.id);

    this.signals.viewedProducts = [productId].concat(
      this.signals.viewedProducts.filter(function (id) {
        return id !== productId;
      })
    ).slice(0, MAX_ITEMS.viewedProducts);

    if (product.productType) {
      this.signals.categoryAffinity[product.productType] =
        (this.signals.categoryAffinity[product.productType] || 0) + 1;
    }

    if (product.vendor) {
      this.signals.vendorAffinity[product.vendor] =
        (this.signals.vendorAffinity[product.vendor] || 0) + 1;
    }

    if (product.price && product.price > 0) {
      this.updatePriceRange(Number(product.price));
    }

    this.save();
  };

  PersonalizationSignals.prototype.updatePriceRange = function (price) {
    if (!this.signals.priceRange) {
      this.signals.priceRange = {
        min: price,
        max: price,
        avg: price,
        prices: [price],
      };
      return;
    }

    var range = this.signals.priceRange;
    range.prices.push(price);
    range.prices = range.prices.slice(-MAX_ITEMS.priceHistory);

    var min = Infinity;
    var max = -Infinity;
    var sum = 0;

    for (var i = 0; i < range.prices.length; i += 1) {
      var value = Number(range.prices[i]) || 0;
      min = Math.min(min, value);
      max = Math.max(max, value);
      sum += value;
    }

    range.min = min === Infinity ? 0 : min;
    range.max = max === -Infinity ? 0 : max;
    range.avg = range.prices.length ? sum / range.prices.length : 0;
  };

  PersonalizationSignals.prototype.trackSearch = function (term) {
    if (!term || !term.trim()) return;

    var clean = term.trim().toLowerCase();
    if (clean.length < 2) return;

    this.signals.searchTerms = [clean].concat(
      this.signals.searchTerms.filter(function (t) {
        return t !== clean;
      })
    ).slice(0, MAX_ITEMS.searchTerms);

    this.save();
  };

  PersonalizationSignals.prototype.captureUTMParams = function () {
    if (!this.hasSessionStorage) return;

    try {
      var params = new URLSearchParams(window.location.search);
      var campaign = params.get('utm_campaign');
      var source = params.get('utm_source');
      var medium = params.get('utm_medium');

      if (!campaign && !source && !medium) return;

      sessionStorage.setItem(
        STORAGE_KEYS.utmCampaign,
        JSON.stringify({
          campaign: campaign || '',
          source: source || '',
          medium: medium || '',
          timestamp: nowMs(),
        })
      );
    } catch (e) {
      // Ignore URL/session parsing failures.
    }
  };

  PersonalizationSignals.prototype.getUTMData = function () {
    if (!this.hasSessionStorage) return null;
    return safeParse(sessionStorage.getItem(STORAGE_KEYS.utmCampaign), null);
  };

  PersonalizationSignals.prototype.getSignals = function () {
    return {
      viewedProducts: this.signals.viewedProducts,
      categoryAffinity: this.signals.categoryAffinity,
      vendorAffinity: this.signals.vendorAffinity,
      searchTerms: this.signals.searchTerms,
      priceRange: this.signals.priceRange,
      utm: this.getUTMData(),
    };
  };

  PersonalizationSignals.prototype.getViewedIndex = function (productId) {
    return this.signals.viewedProducts.indexOf(String(productId));
  };

  PersonalizationSignals.prototype.getCategoryAffinityScore = function (category) {
    if (!category) return 0;

    var affinity = this.signals.categoryAffinity[category] || 0;
    var values = Object.values(this.signals.categoryAffinity);
    var maxAffinity = values.length ? Math.max.apply(null, values) : 1;
    return maxAffinity > 0 ? affinity / maxAffinity : 0;
  };

  PersonalizationSignals.prototype.getVendorAffinityScore = function (vendor) {
    if (!vendor) return 0;

    var affinity = this.signals.vendorAffinity[vendor] || 0;
    var values = Object.values(this.signals.vendorAffinity);
    var maxAffinity = values.length ? Math.max.apply(null, values) : 1;
    return maxAffinity > 0 ? affinity / maxAffinity : 0;
  };

  PersonalizationSignals.prototype.getPriceRangeScore = function (price) {
    var value = Number(price) || 0;

    if (!this.signals.priceRange) return 0.5;

    var min = Number(this.signals.priceRange.min) || 0;
    var max = Number(this.signals.priceRange.max) || 0;
    var avg = Number(this.signals.priceRange.avg) || 0;

    if (value >= min && value <= max) {
      var maxDistance = Math.max(Math.abs(avg - min), Math.abs(max - avg));
      if (maxDistance <= 0) {
        return 1;
      }

      var distance = Math.abs(value - avg);
      return Math.max(0, 1 - distance / (maxDistance * 2));
    }

    var range = Math.max(max - min, 1);
    var outsideDistance = value < min ? min - value : value - max;
    return Math.max(0, 0.5 - outsideDistance / range);
  };

  PersonalizationSignals.prototype.getSearchTermMatches = function (text) {
    if (!text || !this.signals.searchTerms.length) return 0;

    var haystack = text.toLowerCase();
    var matches = 0;
    for (var i = 0; i < this.signals.searchTerms.length; i += 1) {
      if (haystack.indexOf(this.signals.searchTerms[i]) !== -1) {
        matches += 1;
      }
    }

    return matches;
  };

  PersonalizationSignals.prototype.clearAll = function () {
    if (this.hasLocalStorage) {
      try {
        Object.keys(STORAGE_KEYS).forEach(function (keyName) {
          localStorage.removeItem(STORAGE_KEYS[keyName]);
        });
      } catch (e) {
        // Ignore.
      }
    }

    if (this.hasSessionStorage) {
      try {
        sessionStorage.removeItem(STORAGE_KEYS.utmCampaign);
      } catch (e) {
        // Ignore.
      }
    }

    this.signals = getEmptySignals();
  };

  window.personalizationSignals = new PersonalizationSignals();
})();
